import { Column, Row, SmartTooltip, Text } from '~/commonComponents';
import { IPendingReview } from '~/domain/ShiftReview';
import { getShouldEnforcePermanentJobV2 } from '~/growthbook';
import { Colors } from '~/themes/colors';
import { calculateAdjustedBreakTime, calculateAdjustedShiftTime, formatTime } from '../../utils';

interface IProps {
  it: IPendingReview;
}

export const AdjustmentDetailV2 = ({ it }: IProps) => {
  const hasAdjustment = it.hasAdjustShiftTime || it.hasAdjustBreakTime;

  return (
    <Column>
      {getShouldEnforcePermanentJobV2() && (
        <Column
          alignSelf="flex-start"
          paddingBlock={2}
          paddingInline={10}
          marginBottom={5}
          borderRadius={8}
          backgroundColor={
            it?.isOnsiteInterview ? Colors.jobs_interview_background : Colors.jobs_shift_background
          }
        >
          <Text>{it?.isOnsiteInterview ? 'INTERVIEW' : 'SHIFT'}</Text>
        </Column>
      )}
      <Row gap={5} flex={1}>
        <Text bold color="neutral_500">
          {it.shift.localDate}
          {hasAdjustment ? ' •' : ''}
        </Text>
        {hasAdjustment && (
          <SmartTooltip
            content={
              <Column>
                <Text
                  color={Colors.neutral_500}
                  textDecorationLine={it.hasAdjustShiftTime ? 'line-through' : 'none'}
                >
                  {it.shift?.localStartTime} - {it.shift?.localEndTime}
                </Text>
                <Text
                  color={Colors.neutral_500}
                  textDecorationLine={it.hasAdjustBreakTime ? 'line-through' : 'none'}
                >
                  Meal Break: {formatTime(parseInt(it.shift?.breakTime, 10), false)}
                </Text>
              </Column>
            }
            hideArrow
            style={{
              Content: {
                paddingBlock: 14,
                paddingInline: 20,
              },
              Portal: {
                backgroundColor: Colors.white,
                borderRadius: 0,
              },
            }}
            position="bottom"
            alignment="center"
            trigger="hover"
          >
            <Text textDecoration="underline" className="hover-bold" flexGrow={1}>
              Original Hours
            </Text>
          </SmartTooltip>
        )}
      </Row>
      <Column>
        <Text color={Colors.neutral_500}>
          {it.hasAdjustShiftTime
            ? `${it.adjustment?.localStartTime} - ${it.adjustment?.localEndTime}`
            : `${it.shift.localStartTime} - ${it.shift.localEndTime}`}
          <Text bold color="warning_500" paddingLeft={5}>
            {it.hasAdjustShiftTime &&
              calculateAdjustedShiftTime(
                it.shift.localStartTime,
                it.shift.localEndTime,
                it.adjustment?.localStartTime,
                it.adjustment?.localEndTime,
              )}
          </Text>
        </Text>
      </Column>
      <Column>
        <Text color={Colors.neutral_500}>
          Meal Break:{' '}
          {it.hasAdjustBreakTime
            ? formatTime(parseInt(it.adjustment?.breakTime || '', 10), false)
            : formatTime(parseInt(it.shift?.breakTime, 10), false)}
          <Text bold color="warning_500" paddingLeft={5}>
            {it.hasAdjustBreakTime &&
              calculateAdjustedBreakTime(it.shift.breakTime, it.adjustment?.breakTime)}
          </Text>
        </Text>
      </Column>
    </Column>
  );
};
